"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = __importDefault(require("./color"));
var getFontColor = function (_a) {
    var font = _a.theme.palette.font, muted = _a.muted, error = _a.error, warning = _a.warning, success = _a.success;
    if (muted) {
        return font[1];
    }
    if (error) {
        return font[2];
    }
    if (warning) {
        return font[3];
    }
    if (success) {
        return font[4];
    }
    return '';
};
exports.default = (function (_a, defaultColor) {
    var theme = _a.theme, color = _a.color, muted = _a.muted, error = _a.error, warning = _a.warning, success = _a.success;
    if (defaultColor === void 0) { defaultColor = theme.palette.font[0]; }
    return (color ? (0, color_1.default)({ theme: theme, color: color }) : getFontColor({ theme: theme, muted: muted, error: error, warning: warning, success: success }) || defaultColor);
});
